// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `quiz-popup .quiz-background {
  position: fixed;
  z-index: 4;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: var(--motes-black);
  opacity: 0.95;
  animation: fadeInBg;
  animation-duration: 300ms;
  animation-fill-mode: forwards;
  touch-action: none;
}
quiz-popup .quiz {
  position: fixed;
  pointer-events: none;
  touch-action: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  margin: var(--safe-area-top) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);
}
@keyframes fadeInBg {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.95;
  }
}
quiz-popup .quiz .quiz-content {
  position: absolute;
  bottom: 0;
  pointer-events: initial;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  left: 50%;
  border-radius: var(--border-radius);
  overflow: hidden;
  transform: translateY(150%) translateX(-50%);
  transition: 300ms;
}
quiz-popup .quiz .quiz-content .hide-bonus {
  opacity: 0;
  height: 0;
  display: block;
}
quiz-popup .quiz .quiz-content .question-media-container {
  width: 100%;
  position: relative;
  aspect-ratio: 16/9;
}
quiz-popup .quiz .quiz-content .question-media-container .question-media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 10px;
}
quiz-popup .quiz .quiz-content .question-container,
quiz-popup .quiz .quiz-content .answer-container {
  padding: 12px;
}
quiz-popup .quiz .quiz-content .answer-label {
  display: inline-block;
  vertical-align: middle;
  width: 80%;
}
quiz-popup .quiz .quiz-content .text-input-answer {
  padding: 2px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
}
quiz-popup .quiz .quiz-content .text-input-answer input {
  width: 100%;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid black;
}
quiz-popup .quiz .quiz-content .question {
  font-weight: bold;
  margin-top: 1em;
}
quiz-popup .quiz .quiz-content .answer {
  display: block;
  width: 100%;
  transform: translateX(120%);
  animation: show-answer-option 700ms;
  animation-fill-mode: forwards;
  --delay: 150ms;
  text-transform: none;
}
quiz-popup .quiz .quiz-content .answer:nth-child(1) {
  animation-delay: calc(var(--delay) * 1);
}
quiz-popup .quiz .quiz-content .answer:nth-child(2) {
  animation-delay: calc(var(--delay) * 2);
}
quiz-popup .quiz .quiz-content .answer:nth-child(3) {
  animation-delay: calc(var(--delay) * 3);
}
quiz-popup .quiz .quiz-content .answer:nth-child(4) {
  animation-delay: calc(var(--delay) * 4);
}
quiz-popup .quiz .quiz-content .answer:nth-child(5) {
  animation-delay: calc(var(--delay) * 5);
}
quiz-popup .quiz .quiz-content .answer:nth-child(6) {
  animation-delay: calc(var(--delay) * 6);
}
@keyframes show-answer-option {
  0% {
    transform: translateX(120%);
  }
  100% {
    transform: translateX(0);
  }
}
quiz-popup .quiz .quiz-content .answer:disabled {
  transition: 200ms;
  background-color: rgb(43, 43, 43);
}
quiz-popup .quiz .quiz-content .selected-answer:disabled {
  transition: 2500ms;
  opacity: 1;
  transform: scale(1.04);
  overflow: hidden;
  background-color: var(--primary-color);
  border: 1px solid #efbb56;
}
quiz-popup .quiz .quiz-content .selected-answer::after {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
  animation: button-shine 4s infinite alternate;
  transform: rotate(90deg);
}
@keyframes button-shine {
  0% {
    transform: translate(-120%, -120%) rotate(90deg);
  }
  60% {
    transform: translate(90%, 90%) rotate(120deg);
  }
  100% {
    transform: translate(0%, 0%) rotate(130deg);
  }
}
quiz-popup .quiz .quiz-content h2 {
  margin-top: 2px;
  margin-bottom: 12px;
}
quiz-popup .quiz .quiz-content .quiz-content-answer {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform: translateX(100%);
  background-color: var(--motes-white);
  transition: 300ms;
}
quiz-popup .quiz .quiz-content .content-answer-shown {
  transform: translateX(0);
}
quiz-popup .quiz .quiz-content .motes-button-blue,
quiz-popup .quiz .quiz-content .motes-button-green {
  width: 100%;
  display: flex;
  align-items: center;
}
quiz-popup .quiz .quiz-content .motes-button-blue > div,
quiz-popup .quiz .quiz-content .motes-button-green > div {
  flex-grow: 1;
}
quiz-popup .quiz .quiz-content .penalty-countdown {
  margin-top: 10px;
  font-size: 1.4em;
  text-align: center;
}
quiz-popup .quiz .quiz-content .countdown {
  font-size: 1.8em;
}
quiz-popup .quiz .content-shown {
  transform: translateY(0) translateX(-50%);
  transition: 300ms;
}
quiz-popup .close-quiz {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  z-index: 1;
  width: 2.5em;
  height: 2.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: var(--motes-black);
  background-color: var(--motes-white);
  cursor: pointer;
  pointer-events: initial;
}
quiz-popup .close-quiz .close-circle span {
  font-size: 2em;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/quiz-popup/quiz-popup.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;AAAR;AAGI;EACI,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8FAAA;AADR;AAGQ;EACI;IACI,UAAA;EADd;EAIU;IACI,aAAA;EAFd;AACF;AAKQ;EACI,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,4CAAA;EACA,iBAAA;AAHZ;AAKY;EACI,UAAA;EACA,SAAA;EACA,cAAA;AAHhB;AAMY;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;AAJhB;AAMgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;AAJpB;AAQY;;EAEI,aAAA;AANhB;AASY;EACI,qBAAA;EAEA,sBAAA;EACA,UAAA;AARhB;AAWY;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAThB;AAWgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AATpB;AAaY;EACI,iBAAA;EACA,eAAA;AAXhB;AAcY;EACI,cAAA;EACA,WAAA;EAEA,2BAAA;EACA,mCAAA;EACA,6BAAA;EACA,cAAA;EACA,oBAAA;AAbhB;AAgBY;EACI,uCAAA;AAdhB;AAiBY;EACI,uCAAA;AAfhB;AAkBY;EACI,uCAAA;AAhBhB;AAmBY;EACI,uCAAA;AAjBhB;AAoBY;EACI,uCAAA;AAlBhB;AAqBY;EACI,uCAAA;AAnBhB;AAsBY;EACI;IACI,2BAAA;EApBlB;EAuBc;IACI,wBAAA;EArBlB;AACF;AAwBY;EACI,iBAAA;EACA,iCAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,sCAAA;EACA,yBAAA;AAvBhB;AA0BY;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gHAAA;EACA,6CAAA;EACA,wBAAA;AAxBhB;AA2BY;EACI;IACI,gDAAA;EAzBlB;EA4Bc;IACI,6CAAA;EA1BlB;EA6Bc;IACI,2CAAA;EA3BlB;AACF;AA8BY;EACI,eAAA;EACA,mBAAA;AA5BhB;AA+BY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;AA7BhB;AAgCY;EACI,wBAAA;AA9BhB;AAiCY;;EAEI,WAAA;EACA,aAAA;EACA,mBAAA;AA/BhB;AAiCgB;;EACI,YAAA;AA9BpB;AAkCY;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;AAhChB;AAmCY;EACI,gBAAA;AAjChB;AAqCQ;EACI,yCAAA;EACA,iBAAA;AAnCZ;AAuCI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,uBAAA;AArCR;AAuCQ;EACI,cAAA;EACA,aAAA;AArCZ","sourcesContent":["quiz-popup {\n    .quiz-background {\n        position: fixed;\n        z-index: 4;\n        width: 100%;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        background-color: var(--motes-black);\n        opacity: 0.95;\n        animation: fadeInBg;\n        animation-duration: 300ms;\n        animation-fill-mode: forwards;\n        touch-action: none;\n    }\n\n    .quiz {\n        position: fixed;\n        pointer-events: none;\n        touch-action: none;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 4;\n        margin: var(--safe-area-top) var(--safe-area-right) var(--large-spacing) var(--safe-area-left);\n\n        @keyframes fadeInBg {\n            0% {\n                opacity: 0;\n            }\n\n            100% {\n                opacity: 0.95;\n            }\n        }\n\n        .quiz-content {\n            position: absolute;\n            bottom: 0;\n            pointer-events: initial;\n            height: 100%;\n            width: 100%;\n            box-sizing: border-box;\n            left: 50%;\n            border-radius: var(--border-radius);\n            overflow: hidden;\n            transform: translateY(150%) translateX(-50%);\n            transition: 300ms;\n\n            .hide-bonus {\n                opacity: 0;\n                height: 0;\n                display: block;\n            }\n\n            .question-media-container {\n                width: 100%;\n                position: relative;\n                aspect-ratio: 16/9;\n\n                .question-media {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    min-height: 10px;\n                }\n            }\n\n            .question-container,\n            .answer-container {\n                padding: 12px;\n            }\n\n            .answer-label {\n                display: inline-block;\n                // line-height: 20px;\n                vertical-align: middle;\n                width: 80%;\n            }\n\n            .text-input-answer {\n                padding: 2px;\n                width: 100%;\n                box-sizing: border-box;\n                margin-top: 10px;\n\n                input {\n                    width: 100%;\n                    padding: 6px;\n                    border-radius: 4px;\n                    border: 1px solid black;\n                }\n            }\n\n            .question {\n                font-weight: bold;\n                margin-top: 1em;\n            }\n\n            .answer {\n                display: block;\n                width: 100%;\n                // line-height: 40px;\n                transform: translateX(120%);\n                animation: show-answer-option 700ms;\n                animation-fill-mode: forwards;\n                --delay: 150ms;\n                text-transform: none;\n            }\n\n            .answer:nth-child(1) {\n                animation-delay: calc(var(--delay) * 1)\n            }\n\n            .answer:nth-child(2) {\n                animation-delay: calc(var(--delay) * 2)\n            }\n\n            .answer:nth-child(3) {\n                animation-delay: calc(var(--delay) * 3)\n            }\n\n            .answer:nth-child(4) {\n                animation-delay: calc(var(--delay) * 4)\n            }\n\n            .answer:nth-child(5) {\n                animation-delay: calc(var(--delay) * 5)\n            }\n\n            .answer:nth-child(6) {\n                animation-delay: calc(var(--delay) * 6)\n            }\n\n            @keyframes show-answer-option {\n                0% {\n                    transform: translateX(120%);\n                }\n\n                100% {\n                    transform: translateX(0);\n                }\n            }\n\n            .answer:disabled {\n                transition: 200ms;\n                background-color: rgb(43, 43, 43);\n            }\n\n            .selected-answer:disabled {\n                transition: 2500ms;\n                opacity: 1;\n                transform: scale(1.04);\n                overflow: hidden;\n                background-color: var(--primary-color);\n                border: 1px solid #efbb56;\n            }\n\n            .selected-answer::after {\n                position: absolute;\n                top: 50%;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, .4), rgba(255, 255, 255, 0));\n                animation: button-shine 4s infinite alternate;\n                transform: rotate(90deg);\n            }\n\n            @keyframes button-shine {\n                0% {\n                    transform: translate(-120%, -120%) rotate(90deg);\n                }\n\n                60% {\n                    transform: translate(90%, 90%) rotate(120deg);\n                }\n\n                100% {\n                    transform: translate(0%, 0%) rotate(130deg);\n                }\n            }\n\n            h2 {\n                margin-top: 2px;\n                margin-bottom: 12px;\n            }\n\n            .quiz-content-answer {\n                display: flex;\n                flex-direction: column;\n                position: absolute;\n                top: 0;\n                left: 0;\n                height: 100%;\n                width: 100%;\n                transform: translateX(100%);\n                background-color: var(--motes-white);\n                transition: 300ms;\n            }\n\n            .content-answer-shown {\n                transform: translateX(0);\n            }\n\n            .motes-button-blue,\n            .motes-button-green {\n                width: 100%;\n                display: flex;\n                align-items: center;\n\n                >div {\n                    flex-grow: 1;\n                }\n            }\n\n            .penalty-countdown {\n                margin-top: 10px;\n                font-size: 1.4em;\n                text-align: center;\n            }\n\n            .countdown {\n                font-size: 1.8em;\n            }\n        }\n\n        .content-shown {\n            transform: translateY(0) translateX(-50%);\n            transition: 300ms;\n        }\n    }\n\n    .close-quiz {\n        position: absolute;\n        top: 0.5em;\n        right: 0.5em;\n        z-index: 1;\n        width: 2.5em;\n        height: 2.5em;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n        color: var(--motes-black);\n        background-color: var(--motes-white);\n        cursor: pointer;\n        pointer-events: initial;\n\n        .close-circle span {\n            font-size: 2em;\n            display: flex;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
